/**
 * n-cross-sell-guard.js
 * ─────────────────────
 * Rimuove dal carrello i prodotti cross-sell (Kit Viso scontato)
 * se il prodotto regalo a cui sono associati viene rimosso.
 *
 * Funzionamento:
 *  - Gli articoli cross-sell hanno le proprietà nascoste:
 *      _cross_sell   = "true"
 *      _requires_handle = "<handle-del-prodotto-regalo>"
 *  - Lo script legge il carrello, trova i cross-sell orfani
 *    (il cui _requires_handle non è più presente) e li rimuove.
 *  - Si attiva ad ogni aggiornamento del carrello (evento cart:refresh
 *    e MutationObserver sul DOM del carrello).
 */

(function () {
  'use strict';

  var RUNNING = false;

  function guardCart() {
    if (RUNNING) return;
    RUNNING = true;

    fetch(window.Shopify.routes.root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Classifica gli articoli nel carrello */
        var regularItems = [];
        var giftItems = [];
        var crossSellItems = [];

        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (props._cross_sell === 'true') {
            crossSellItems.push(item);
          } else if (props._gift === 'true') {
            giftItems.push(item);
          } else {
            regularItems.push(item);
          }
        });

        /* Raccoglie gli handle dei prodotti "normali" nel carrello */
        var presentHandles = {};
        regularItems.forEach(function (item) {
          presentHandles[item.handle] = true;
        });

        /* Trova orfani: cross-sell senza il prodotto associato */
        var orphans = crossSellItems.filter(function (item) {
          var req = item.properties._requires_handle;
          return req && !presentHandles[req];
        });

        /* Se non ci sono più prodotti normali, anche omaggi e cross-sell vanno rimossi */
        if (regularItems.length === 0) {
          orphans = giftItems.concat(crossSellItems);
        }

        if (orphans.length === 0) {
          RUNNING = false;
          return;
        }

        /* Costruisce il payload per rimuovere gli orfani (quantity = 0) */
        var updates = {};
        orphans.forEach(function (item) {
          updates[item.key] = 0;
        });

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (res) {
        if (res) {
          return res.json();
        }
      })
      .then(function (updatedCart) {
        if (updatedCart) {
          /* Se il carrello è ora vuoto, ricarica la pagina per mostrare lo stato vuoto */
          if (updatedCart.item_count === 0) {
            window.location.reload();
            return;
          }

          /* Altrimenti aggiorna le sezioni */
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          var cartSection = document.querySelector('#main-cart-items');
          if (cartSection) {
            fetch(window.location.pathname + '?sections=' + encodeURIComponent('main-cart-items'))
              .then(function (r) { return r.json(); })
              .then(function (sections) {
                var html = sections['main-cart-items'];
                if (html) {
                  var container = document.getElementById('main-cart-items');
                  if (container) {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = html;
                    var newContent = tmp.querySelector('#main-cart-items');
                    if (newContent) {
                      container.innerHTML = newContent.innerHTML;
                    }
                  }
                }
              });
          }
        }
        RUNNING = false;
      })
      .catch(function () {
        RUNNING = false;
      });
  }

  /* ── Trigger: ascolta aggiornamenti del carrello ── */

  /* 1. Evento custom (emesso dal tema Dawn e dalla sezione cross-sell) */
  document.addEventListener('cart:refresh', function () {
    setTimeout(guardCart, 500);
  });

  /* 2. MutationObserver sul contenuto del carrello (fallback) */
  var cartContainer = document.querySelector('.js-contents');
  if (cartContainer) {
    var observer = new MutationObserver(function () {
      setTimeout(guardCart, 500);
    });
    observer.observe(cartContainer, { childList: true, subtree: true });
  }

  /* 3. Controlla una volta al caricamento della pagina */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(guardCart, 300);
    });
  } else {
    setTimeout(guardCart, 300);
  }
})();